import styled from '@emotion/styled';

export const Content = styled.div`
    .modal {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        display: findByLabelText;
        align-items: center;
        justify-content: center;
    }

    .modal-content{
        width: 500px;
        background-color: #fff;
    }

    .modal-header !important{
        background-color: black;
        padding: 10px;
    }

    .modal-title{
        margin: 0;
    }

    .modal-body{
        padding: 10px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
    }

    `;

export const Modal = styled.div`

    `;
